// Búsqueda dentro de la conversación: comparación sin acentos y resaltado en el HTML

const normalizar = (texto) => String(texto ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const htmlATexto = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
    return (doc.body.textContent || '').replace(/\u00A0/g, ' ');
};

export const contieneTermino = (html, termino) => {
    const aguja = normalizar(termino).trim();
    if (!aguja) return false;
    return normalizar(htmlATexto(html)).includes(aguja);
};

/**
 * Envuelve las coincidencias en <mark> recorriendo solo nodos de texto, para no
 * romper el marcado del mensaje (enlaces, listas, negritas…).
 */
export const resaltarCoincidencias = (html, termino) => {
    const aguja = normalizar(termino).trim();
    if (!html || !aguja) return html;

    const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
    const paseo = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
    const nodos = [];
    while (paseo.nextNode()) nodos.push(paseo.currentNode);

    nodos.forEach((nodo) => {
        const texto = nodo.textContent;
        const plano = normalizar(texto);
        if (!plano.includes(aguja)) return;

        const fragmento = doc.createDocumentFragment();
        let desde = 0;
        let encontrado = plano.indexOf(aguja, desde);

        while (encontrado !== -1) {
            if (encontrado > desde) {
                fragmento.appendChild(doc.createTextNode(texto.slice(desde, encontrado)));
            }
            const marca = doc.createElement('mark');
            marca.className = 'tk-marca';
            marca.textContent = texto.slice(encontrado, encontrado + aguja.length);
            fragmento.appendChild(marca);

            desde = encontrado + aguja.length;
            encontrado = plano.indexOf(aguja, desde);
        }

        if (desde < texto.length) {
            fragmento.appendChild(doc.createTextNode(texto.slice(desde)));
        }
        nodo.replaceWith(fragmento);
    });

    return doc.body.innerHTML;
};
